module.exports = __webpack_public_path__ + "img/product-selection.e20df285.jpg";